const toFixed = (n,precision = 3) => n.toFixed(precision);

export const getNavbarOffset = (selector='#page-header') => {
  const offsetElement = document.querySelector(selector);
  return ()=>offsetElement ? offsetElement.getBoundingClientRect().height : 0;
}

export const centerAnchor = ()=>window.innerHeight / 2;
export const topAnchor = ()=>0;
export const bottomAnchor = ()=>window.innerHeight;

const inlineAnchors = {
  center:centerAnchor,
  top:topAnchor,
  bottom:bottomAnchor
};

export default function visibility({
  selector = '.visibility',
  smooth=2.5,
  navbarOffset = getNavbarOffset(),
  anchor = centerAnchor,
  onUpdate,
  onUpdateElement,
  onOffsetChange,
  onCreate,
  onDestroy
} = {}){
  if(Array.isArray(selector)) selector = selector.join(',');
  const elements = Array.from(document.querySelectorAll(selector));
  const offsetsMap = [];

  let destroyed = false;

  const update = ()=>{
    onUpdate&&onUpdate([...elements]);
    elements.forEach((element,index) => {
      const {top} = element.getBoundingClientRect();

      let anchorValue = element.dataset.anchor ? inlineAnchors[element.dataset.anchor]() : anchor();

      const newOffset = Math.max(-.5,Math.min(.5,(top - anchorValue - navbarOffset()) / window.innerHeight));

      if(isNaN(offsetsMap[index])){
        offsetsMap[index] = newOffset;
        element.style.setProperty('--offset',newOffset);
        onOffsetChange&&onOffsetChange(element,newOffset);
      }

      const lastOffset = offsetsMap[index];

      offsetsMap[index] += (newOffset - offsetsMap[index]) / smooth;

      const lowPrecisionOld = toFixed(lastOffset);

      const lowPrecisionNext = toFixed(offsetsMap[index]);

      if(lowPrecisionOld !== lowPrecisionNext){
        element.style.setProperty('--offset',offsetsMap[index]);
        onOffsetChange&&onOffsetChange(element,offsetsMap[index]);
      }

      if(newOffset < 0 && !element.classList.contains('was-visible')) {
        element.classList.add('was-visible');
      }

      if(newOffset < .35 && !element.classList.contains('was-partially-visible')) {
        element.classList.add('was-partially-visible');
      }

      onUpdateElement&&onUpdateElement(element,index,offsetsMap[index]);
    });
  }

  onCreate&&onCreate([...elements]);

  let lastTick = 0;

  const tick = (delta)=>{
    !destroyed&&requestAnimationFrame(tick);
    const time = performance.now();

    if(time - lastTick > 1000 / 60){
      lastTick = time;
      update();
    }
  }
  if(elements.length){
    requestAnimationFrame(tick);
  }

  return ()=>{
    destroyed = true;
    onDestroy&&onDestroy();
  }
}